import type { Store } from '@ms/yammer-data/dist/state/types';
import Main from 'components/Main';
import React from 'react';
import { render } from 'react-dom';
import type { YammerTeamsState } from 'state/types';

interface RendererOptions {
  readonly store: Store<YammerTeamsState>;
  readonly target: HTMLElement;
  readonly error?: unknown;
  readonly etag?: string;
}

export type Renderer = (options: RendererOptions) => void;

const renderer: Renderer = ({ store, target, error, etag }) => {
  render(<Main store={store} error={error} etag={etag} />, target);
};

export default renderer;
